// fork from RBMC
import startCloudinaryResponsive from '../utils/rbata.cloudinary';

const facetBar = {
    pageBody:      undefined,
    hoverOutTimer: undefined,
    hoverInTimer:  undefined,
    cacheSelectors() {
        this.pageBody = $(document.body);
    },
    bindHandler() {
        this.pageBody.on('mouseenter', '.dropdown--facet', (evt) => {

            this.hoverInTimer = setTimeout(() => {
                $(evt.currentTarget).find('.dropdown-toggle--facet').dropdown('show');
            }, 350)

            if (this.hoverOutTimer) {
                clearTimeout(this.hoverOutTimer);
                this.hoverOutTimer = undefined;
                this.pageBody.find('.dropdown--facet.show .dropdown-toggle--facet').dropdown('hide');
            }

        });

        this.pageBody.on('mouseleave', '.dropdown--facet', (evt) => {
            this.hoverOutTimer = setTimeout(() => {
                $(evt.currentTarget).find('.dropdown-toggle--facet').dropdown('hide');
            }, 350);

            if (this.hoverInTimer) {
                clearTimeout(this.hoverInTimer);
                this.hoverInTimer = undefined;
                this.pageBody.find('.dropdown--facet.show .dropdown-toggle--facet').dropdown('hide');
            }
        });

        // avoid dropdown menu close on click inside
        this.pageBody.on('click', '.dropdown--facet, .dropdown-menu--mfacet', (evt) => {
            evt.stopPropagation();
        });
    }
};

$(() => {
    if ($('#product-grid-page').length) {
        facetBar.cacheSelectors();
        facetBar.bindHandler();
        startCloudinaryResponsive();
    }
});

export default facetBar;
